import React from 'react';
import './Header.css';

interface HeaderProps {
  onLogoClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onLogoClick }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo" onClick={onLogoClick}>
          <img src="/plumberseo.svg" alt="PlumberSEO" className="logo-image" />
          <span className="logo-text">AI Visibility Platform</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
